export default __webpack_public_path__ + "static/media/element_1.1a7236e6.jpg";